import { type FormEvent, useState } from 'react'
import './Login.scss'
import cookingIcon from '../assets/cooking-icon.svg'
import { login, type User } from '../utils/loginUtils'

interface LoginProps {
  setLoggedInUser: (loggedInUser: User | null) => void
}

function Login({ setLoggedInUser }: LoginProps) {
  const [username, setUsername] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault()

    setError('')

    try {
      const user = await login(username, password)
      setLoggedInUser(user)
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Login failed')
    }
  }

  return (
    <div className="login-container">
      <div className="login-card">
        <div className="image-container">
          <div className="image-circle">
            <img src={cookingIcon} alt="Cooking" className="icon" />
          </div>
        </div>

        {/* Login Form */}
        <form onSubmit={handleSubmit} className="login-form">
          <div className="login-form-fields">
            <div className="form-group">
              <label htmlFor="username" className="form-label">
                Usuario:
              </label>
              <input
                type="text"
                id="username"
                value={username}
                onChange={e => setUsername(e.target.value)}
                className="form-input"
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="password" className="form-label">
                Contraseña:
              </label>
              <input
                type="password"
                id="password"
                value={password}
                onChange={e => setPassword(e.target.value)}
                className="form-input"
                required
              />
            </div>
          </div>

          <div className="loginErrorMessage">{error}</div>

          <button type="submit" className="submit-button">
            Sign In
          </button>
        </form>
      </div>
    </div>
  )
}

export default Login
